export const TEAM_MEMBERS = [
  {
    id: "1",
    name: "Caleb Oller",
    role: "Partner",
    location: "Providence, RI",
    image: "/assets/team/caleb.webp",
    locationImage: "/assets/locations/small/caleb-location.webp",
    emoji: "🏔",
    emojiLabel: "Chief Email Writer",
    slug: "caleb",
  },
  {
    id: "2",
    name: "Matt McInerney",
    role: "Partner",
    location: "Providence, RI",
    image: "/assets/team/matt.webp",
    locationImage: "/assets/locations/small/matt-location.webp",
    emoji: "🎶",
    emojiLabel: "Original Tuneship Champ",
    slug: "matt",
  },
  {
    id: "3",
    name: "Angela Sheppard",
    role: "Engineering Director",
    location: "Topsail Beach, NC",
    image: "/assets/team/angela.webp",
    locationImage: "/assets/locations/small/angela-location.webp",
    emoji: "🐕‍🦺",
    emojiLabel: "Dog Treat Dispenser",
    slug: "angela",
  },
  {
    id: "4",
    name: "Samantha Monarch",
    role: "Design Director",
    location: "Chicago, IL",
    image: "/assets/team/samantha.webp",
    locationImage: "/assets/locations/small/samantha-location.webp",
    emoji: "🤢",
    emojiLabel: "Puke Green Aficionado",
    slug: "samantha",
  },
  {
    id: "5",
    name: "Megan Coyle",
    role: "People Director",
    location: "Salem, OR",
    image: "/assets/team/megan.webp",
    locationImage: "/assets/locations/small/megan-location.webp",
    emoji: "🥣",
    emojiLabel: "Soup Newsletter Patron",
    slug: "megan",
  },
  {
    id: "7",
    name: "Samina Khan",
    role: "Staff Engineer",
    location: "Broomfield, CO",
    image: "/assets/team/samina.webp",
    locationImage: "/assets/locations/small/samina-location.webp",
    emoji: "🐈‍⬛",
    emojiLabel: "Senior Noob",
    slug: "samina",
  },
  {
    id: "8",
    name: "Natasha Johnson",
    role: "Senior Front End Engineer",
    location: "Richmond, VA",
    image: "/assets/team/natasha.webp",
    locationImage: "/assets/locations/small/natasha-location.webp",
    emoji: "🚶🏾‍♀️",
    emojiLabel: "Big Stepper",
    slug: "natasha",
  },
  {
    id: "9",
    name: "Baxter Estes",
    role: "Staff Designer",
    location: "Los Angeles, CA",
    image: "/assets/team/baxter.webp",
    locationImage: "/assets/locations/small/baxter-location.webp",
    emoji: "🤠",
    emojiLabel: "Emoji Aesthete",
    slug: "baxter",
  },
  {
    id: "10",
    name: "Elias Mulhall",
    role: "Staff Engineer",
    location: "Baltimore, MD",
    image: "/assets/team/elias.webp",
    locationImage: "/assets/locations/small/elias-location.webp",
    emoji: "🐾",
    emojiLabel: "Backing Up Dog Photos",
    slug: "elias",
  },
] as const;
